var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppdoneNoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46967 11.9111C5.76256 11.6182 6.23744 11.6182 6.53033 11.9111L9.55999 14.9408C9.97228 15.3531 10.6387 15.3524 11.0485 14.9427L17.1097 8.88147C17.4026 8.58857 17.8774 8.58857 18.1703 8.88147C18.4632 9.17436 18.4632 9.64923 18.1703 9.94213L12.1091 16.0033C11.1121 17.0004 9.49593 16.9981 8.49933 16.0014L5.46967 12.9718C5.17678 12.6789 5.17678 12.204 5.46967 11.9111Z",
    fill: "#32872C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppdoneNoCircle);
export default __webpack_public_path__ + "static/media/app.done_no_circle.aa33f6c16f60f83c695d74faf39c77fd.svg";
export { ForwardRef as ReactComponent };